import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export class PaneComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return _jsx("div", { className: "pane" });
    }
}
//# sourceMappingURL=paneComponent.js.map